
  export const style={
    inpuStyle:{
      colorInput:"#A9CFC9"
    },
    url:{
      urlClient:"https://pegueidasophie.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/primary_logo_client_pegueidasophie.png",
      secondaryLogonLogo: "null",
    },
    variables:{
       customMenuItem: true,
       autoRegister: false,
       recaptchaVersion : "V2"
    },
    CurrencyName:{
      name:"SophieCoin/SophieCoins"
    },
    teamName:{
      name:"Peguei da Sophie"
    },
    hasToken: false,
    hostHeader: "pegueidasophie"
  }
